//defines breakpoints for responsive design

export default {
    xs: 380,
    small: 768,
    medium: 992,
    large: 1200
}